<template>
  <div>
    <ProductRecommendationsProvider
      :selectorName="DY_API_CAMPAIGN_SELECTOR_NAMES.pdpProductRecommendations"
      :availablePositions="Object.values(PRODUCT_RECOMMENDATIONS_POSITIONS)"
      :currentPosition="position"
      :fallbackTargetPosition="PRODUCT_RECOMMENDATIONS_POSITIONS.bottom"
      :excludeProductId="currentSpreeProduct.id"
      #default="recomendationData"
    >
      <ProductRecommendationsCards v-bind="recomendationData" :genderToShow="selectedGender" />
    </ProductRecommendationsProvider>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { DY_API_CAMPAIGN_SELECTOR_NAMES } from '@/config/constants'
import ProductRecommendationsProvider from '@/components/ProductRecommendations/ProductRecommendationsProvider.vue'
import ProductRecommendationsCards from '@/components/ProductRecommendations/ProductRecommendationsCards.vue'

export const PRODUCT_RECOMMENDATIONS_POSITIONS = {
  top: 'top',
  afterSpecs: 'after-specs',
  bottom: 'bottom',
}

export default {
  name: 'Recommendations',
  components: {
    ProductRecommendationsProvider,
    ProductRecommendationsCards,
  },

  props: {
    position: {
      type: String,
      validator(value) {
        return Object.values(PRODUCT_RECOMMENDATIONS_POSITIONS).includes(value)
      },
    },
  },

  data() {
    return {
      DY_API_CAMPAIGN_SELECTOR_NAMES,
      PRODUCT_RECOMMENDATIONS_POSITIONS,
    }
  },

  computed: {
    ...mapState('product', ['selectedGender']),

    ...mapGetters({
      currentSpreeProduct: 'product/currentSpreeProduct',
    }),
  },
}
</script>
